export const getMimeType = (extension: string | undefined) => {
  if (!extension || !['.jpeg', '.jpg', '.png', '.pdf'].includes(extension))
    return '';

  const mimes = {
    '.jpeg': 'image/jpeg',
    '.jpg': 'image/jpeg',
    '.png': 'image/png',
    '.pdf': 'application/pdf',
  };

  // @ts-ignore
  return mimes[extension];
};
